// src/modules/operaciones/inventarios/components/ModalConstruccion.js
//
// Modal "En construcción": se abre al pulsar un submódulo con `activo: false`.
import React from 'react'; // Importa React para usar JSX
import { useModalA11y } from '../../../../hooks/useModalA11y';  // Hook de accesibilidad para modales

/* ============================ Modal "En construcción" ============================ */

export default function ModalConstruccion({ modulo, onClose }) {
  const { modalRef, inicialRef } = useModalA11y(onClose);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm transition-opacity"
      onClick={onClose}
    >
      <div
        ref={modalRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="titulo-construccion"
        className="bg-white rounded-3xl p-8 max-w-sm w-full shadow-2xl flex flex-col items-center text-center transform scale-100 transition-transform"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="w-16 h-16 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center text-3xl mb-4">
          🚧
        </div>
        <h2 id="titulo-construccion" className="text-xl font-extrabold text-gray-800 mb-2">¡Muy pronto!</h2>
        <p className="text-gray-500 text-sm mb-6">
          El módulo de <strong className="text-gray-800">{modulo}</strong> se encuentra actualmente en construcción. Estamos trabajando para habilitarlo.
        </p>
        <button
          ref={inicialRef}
          onClick={onClose}
          className="w-full py-3 bg-[#007aff] hover:bg-[#005bb5] text-white font-bold rounded-xl transition-colors cursor-pointer"
        >
          Entendido
        </button>
      </div>
    </div>
  );
}